export const SinglePageIcon = (props) => (
  <svg
    width="82"
    height="64"
    viewBox="0 0 82 64"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M78.5 23.6667H61.8333C60.7283 23.6667 59.6685 23.2277 58.8871 22.4463C58.1057 21.6649 57.6667 20.6051 57.6667 19.5V2.83335"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M3.5 11.1667V52.8334C3.5 55.0435 4.37798 57.1631 5.94078 58.7259C7.50358 60.2887 9.6232 61.1667 11.8333 61.1667H70.1667C72.3768 61.1667 74.4964 60.2887 76.0592 58.7259C77.622 57.1631 78.5 55.0435 78.5 52.8334V23.6667L57.6667 2.83336H11.8333C9.6232 2.83336 7.50358 3.71133 5.94078 5.27413C4.37798 6.83694 3.5 8.95655 3.5 11.1667Z"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <g clipPath="url(#clip0_521_8547)">
      <path
        d="M22.75 32.5H34"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M22.75 40H34"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M22.75 47.5H34"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M14 37.5V31.875C14 31.3777 14.1975 30.9008 14.5492 30.5492C14.9008 30.1975 15.3777 30 15.875 30C16.3723 30 16.8492 30.1975 17.2008 30.5492C17.5525 30.9008 17.75 31.3777 17.75 31.875V37.5"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M14 35H17.75"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M15.875 46.25C16.3723 46.25 16.8492 46.4475 17.2008 46.7992C17.5525 47.1508 17.75 47.6277 17.75 48.125C17.75 48.6223 17.5525 49.0992 17.2008 49.4508C16.8492 49.8025 16.3723 50 15.875 50H14V42.5H15.875C16.3723 42.5 16.8492 42.6975 17.2008 43.0492C17.5525 43.4008 17.75 43.8777 17.75 44.375C17.75 44.8723 17.5525 45.3492 17.2008 45.7008C16.8492 46.0525 16.3723 46.25 15.875 46.25ZM15.875 46.25H14"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </g>
    <g clipPath="url(#clip1_521_8547)">
      <path
        d="M57.75 32.5H69"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M57.75 40H69"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M57.75 47.5H69"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M49 37.5V31.875C49 31.3777 49.1975 30.9008 49.5492 30.5492C49.9008 30.1975 50.3777 30 50.875 30C51.3723 30 51.8492 30.1975 52.2008 30.5492C52.5525 30.9008 52.75 31.3777 52.75 31.875V37.5"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M49 35H52.75"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M50.875 46.25C51.3723 46.25 51.8492 46.4475 52.2008 46.7992C52.5525 47.1508 52.75 47.6277 52.75 48.125C52.75 48.6223 52.5525 49.0992 52.2008 49.4508C51.8492 49.8025 51.3723 50 50.875 50H49V42.5H50.875C51.3723 42.5 51.8492 42.6975 52.2008 43.0492C52.5525 43.4008 52.75 43.8777 52.75 44.375C52.75 44.8723 52.5525 45.3492 52.2008 45.7008C51.8492 46.0525 51.3723 46.25 50.875 46.25ZM50.875 46.25H49"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </g>
    <defs>
      <clipPath id="clip0_521_8547">
        <rect width="30" height="30" fill="white" transform="translate(9 25)" />
      </clipPath>
      <clipPath id="clip1_521_8547">
        <rect
          width="30"
          height="30"
          fill="white"
          transform="translate(44 25)"
        />
      </clipPath>
    </defs>
  </svg>
);
